// extracted by mini-css-extract-plugin
export default {"OrderProcessingPage":"OrderProcessingPage_OrderProcessingPage__fA5i7"};